import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useActivateInspectionUiEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.ActivateInspectionUi, false);

  return Boolean(isEnabled);
}
